export default {
	live: (upc: string) => `/live/${upc}`,
	forecast: (upc: string) => `/live/${upc}/forecast`,
	tracks: (upc: string) => `/live/${upc}/tracks`,
};
